import { textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import * as styles from './Hint.module.css';
import aline from './aline.png';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const Hint: React.FC<Props> = ({ children, className }) => (
  <div className={clsx(styles.container, className)}>
    <img className={styles.image} src={aline} alt='aline' />
    <div className={clsx(textSm, styles.content)}>{children}</div>
  </div>
);
